/* * 本页面为门店新增和门店修改界面 * 通过pageType字段来区分：1新增，2修改 * */
<template>
  <div ref="pageView" class="page-view container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title>
        {{ pageTitle }}
        <template slot="breadcrumb">
          <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- content -->
    <section
      class="content-section"
      :style="{ height: resizeViewHeight + 'px' }"
    >
      <div class="form-wrapper">
        <e6-form-extend
          class="e6-from--column-2"
          ref="formExtend"
          :formExtend="formExtend"
          :inline="true"
          label-width="200px"
          :submitLoadingState="loadingState"
          @submitForm="handleSubmitForm"
          @resetForm="handleResetForm"
        >
          <template slot-scope="slotForms">
            <el-form-item
              label="门店名称"
              prop="forms.storeName"
              :rules="[
                {
                  required: true,
                  message: '请输入门店名称',
                  trigger: 'blur'
                },
                { validator: CheckComparyNameLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.storeName"
                placeholder="门店名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="forms.storeType"
              label="门店类型"
              :rules="[
                {
                  required: true,
                  message: '请选择门店类型',
                  trigger: 'change'
                }
              ]"
            >
              <dict-select
                v-model="slotForms.forms.storeType"
                placeholder="门店类型"
                :pkey="'store_type'"
              ></dict-select>
            </el-form-item>
            <el-form-item
              prop="forms.manageType"
              label="经营模式"
              :rules="[
                {
                  required: true,
                  message: '请选择经营模式',
                  trigger: 'change'
                }
              ]"
            >
              <dict-select
                v-model="slotForms.forms.manageType"
                placeholder="经营模式"
                :pkey="'manage_type'"
              ></dict-select>
            </el-form-item>
            <el-form-item
              prop="forms.comparyId"
              label="所属企业"
              :rules="[
                {
                  required: true,
                  message: '请选择所属企业',
                  trigger: 'change'
                }
              ]"
            >
              <el-select
                v-model="slotForms.forms.comparyId"
                collapse-tags
                filterable
                placeholder="所属企业"
              >
                <el-option
                  v-for="item in allCustomer"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <!--<el-form-item prop="forms.provinceId" label="所属省"-->
            <!--:rules="[-->
                <!--{-->
                  <!--required: true,-->
                  <!--message: '请选择所属省',-->
                  <!--trigger: 'change'-->
                <!--}-->
              <!--]"-->
            <!--&gt;-->
              <!--<el-select-->
                <!--v-model="slotForms.forms.provinceId"-->
                <!--placeholder="所属省"-->
                <!--@change="provinceChange"-->
                <!--clearable-->
                <!--filterable-->
              <!--&gt;-->
                <!--<el-option-->
                  <!--v-for="item in provinceList"-->
                  <!--:key="item.id"-->
                  <!--:label="item.name"-->
                  <!--:value="item.id"-->
                <!--&gt;</el-option>-->
              <!--</el-select>-->
            <!--</el-form-item>-->

            <!--<el-form-item prop="forms.cityName" label="所属市"-->
            <!--:rules="[-->
                <!--{-->
                  <!--required: true,-->
                  <!--message: '请选择所属市',-->
                  <!--trigger: 'change'-->
                <!--}-->
              <!--]"-->
            <!--&gt;-->
              <!--<el-select-->
                <!--v-model="slotForms.forms.cityName"-->
                <!--placeholder="所属市"-->
                <!--clearable-->
                <!--filterable-->
              <!--&gt;-->
                <!--<el-option-->
                  <!--v-for="item in cityList"-->
                  <!--:key="item.id"-->
                  <!--:label="item.name"-->
                  <!--:value="item.name"-->
                <!--&gt;</el-option>-->
              <!--</el-select>-->
            <!--</el-form-item>-->
            <div class="group_form">
              <el-form-item
                      label="注册地址"
                      prop="forms.regisArea"
                      class="address"
              >
                <e6-city
                        ref="e6City"
                        :format="$GLOBAL_CONFIG.e6City.format"
                        :placeholder="$GLOBAL_CONFIG.e6City.placeholder"
                        :label="slotForms.forms.regisArea"
                        class="e6-city"
                        @selected="citySelect"
                        :fixed-bin="$GLOBAL_CONFIG.e6City.bin"
                ></e6-city>
              </el-form-item>
              <el-form-item prop="forms.storePosition">
                <el-button
                        @click="selectStorePosition()"
                        :class="slotForms.forms.storePosition ? '' : 'show_tips'"
                >
                  <span :title="storePosition" class="register-txt">{{
                    slotForms.forms.storePosition
                  }}</span>
                  <i class="e6-icon-map_line"></i>
                </el-button>
              </el-form-item>
            </div>
            <!--<el-form-item-->
              <!--label="门店位置"-->
              <!--prop="forms.storePosition"-->
              <!--:rules="[{ validator: CheckRemarkLength, trigger: 'blur' }]"-->
            <!--&gt;-->
              <!--<el-input-->
                <!--v-model="slotForms.forms.storePosition"-->
                <!--placeholder="门店位置"-->
                <!--clearable-->
              <!--&gt;</el-input>-->
            <!--</el-form-item>-->
          </template>
          <template slot="submit">保存</template>
          <template slot="reset">返回</template>
        </e6-form-extend>
      </div>
    </section>
    <!-- content end -->
    <!-- 地图控件 -->
    <small-map
            ref="mapWin"
            title="地图标注"
            :optionMap="optionMap"
            :city="city"
            @showMapInfo="getMapInfo"
    ></small-map>
  </div>
</template>
``
<script>
    import e6City from "e6city";
    import smallMap from "@/components/smallMap/smallMap";
import { SaveStoreInfo, FindStoreInfoById } from '@/api/base/store'
import resizeListener from '_private/mixins/resizeListener'
import { FetchAllCustomer } from '@/api/systemSetting/interfaceUserManager'
import { CheckRemarkLength, CheckComparyNameLength } from '@/utils/validation'
import { FetchGetArea } from '@/api/public'
export default {
    components: { e6City, smallMap },
  mixins: [resizeListener],
  data() {
      // 选择地图详情
      const addressRule = (rule, value, callback) => {
          if (!this.formExtend.forms.storePosition.length) {
              callback("请点击地图选择详情地址");
          } else {
              callback();
          }
      };
    return {
        // 地图跳转传参
        optionMap: {
            lng: "",
            lat: "",
            city: "", //选择的城市名
            level: "", //省、市、区
            location: ""
        },
        city: "", //选择的市区
      breadcrumbs: [
        {
          path: '/home',
          isRedirect: true,
          meta: {
            title: '首页'
          }
        },
        {
          path: '/baseStoreList',
          isRedirect: true,
          meta: {
            title: '门店基础信息'
          }
        }
      ],
      formExtend: {
        forms: {
          provinceName: $GLOBAL_CONFIG.e6City.provinceName,
          provinceId: '',
          cityName: $GLOBAL_CONFIG.e6City.cityName,
          storeType: '',
          manageType: '',
          comparyId: '',
          storeName: '',
          storePosition: '',
            countyName:'',
            regisArea:''
        },
        extends: []
      },
      editState: false,
      allCustomer: [],
      provinceList: [],
      cityList: [],
      CheckRemarkLength: CheckRemarkLength,
      CheckComparyNameLength: CheckComparyNameLength,
      loadingState: false,
        storePosition: ''
    }
  },
  computed: {
    pageType() {
      return this.$route.query.pageType ? this.$route.query.pageType : '1'
    },
    pageTitle() {
      const pageTitle =
        this.pageType === '1' ? '门店基础信息新增' : '门店基础信息修改'
      return pageTitle
    },
    id() {
      return this.$route.query.id
    },
    provinceId() {
      return this.$route.query.provinceId
    }
  },
  created() {
    this.FetchGetArea(0, 1, 1)
    this.initAllCustomer()
    let breadcrumb = {
      path: '/systemSettingDataDictionaryMaintenanceEdit',
      isRedirect: false,
      meta: {
        title: this.pageTitle
      }
    }
    this.breadcrumbs.push(breadcrumb)
    if (this.pageType !== '1') {
      this.FindStoreInfoById({ storeId: this.id })
      this.editState = true
    }
  },
  methods: {
      citySelect(res) {
          if (res.province.name == "澳门") {
              this.cityName("澳门");
              this.optionMap.level = "city";
          } else if (res.province.name == "香港") {
              this.cityName("香港");
              this.optionMap.level = "city";
          } else if (res.province.name == "台湾省") {
              this.cityName("台湾省");
              this.optionMap.level = "city";
          } else {
              this.formExtend.forms.regisArea =
                  res.province.name + res.city.name + res.district.name;
              this.formExtend.forms.provinceName = res.province.name;
              this.formExtend.forms.cityName = res.city.name;
              this.formExtend.forms.countyName = res.district.name;
              this.city = res.city.name;
              this.optionMap.city = res.city.name;
              if (res.district.name === "") {
                  if (res.city.name === "") {
                      this.optionMap.level = "province";
                  } else {
                      this.optionMap.level = "city";
                  }
              } else {
                  this.optionMap.level = "district";
              }
          }
      },
    /**
     *  初始化企业下拉信息
     */
    initAllCustomer() {
      FetchAllCustomer()
        .then(response => {
          if (
            response.result &&
            response.result &&
            Array.isArray(response.result)
          ) {
            this.allCustomer = response.result
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    // 根据父级获取地区下拉框
    FetchGetArea(parentId, type, num) {
      FetchGetArea(parentId, type)
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            if (num == 1) {
              this.provinceList = response.result
            } else if (num == 2) {
              this.cityList = response.result
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
      selectStorePosition() {
          if (!this.formExtend.forms.regisArea.length) {
              this.$message.warning("请先选择省/市/区县");
              return;
          }
          this.optionMap.location = this.formExtend.forms.storePosition;
          this.$refs.mapWin.showMap();
          // this.$refs.mapWin.loadQuery();
      },
    //省选择事件
    provinceChange() {
      this.cityList = []
      this.formExtend.forms.cityName = ''
      let provinceName = this.provinceList.filter(
        t => this.formExtend.forms.provinceId == t.id
      )
      if (provinceName && provinceName.length > 0) {
        this.formExtend.forms.provinceName = provinceName[0].name
      }else {
        this.formExtend.forms.provinceName = ''
      }
      this.FetchGetArea(this.formExtend.forms.provinceId, 2, 2)
    },
    // 修改门店数据时，先获取门店数据信息
    FindStoreInfoById(response) {
      FindStoreInfoById(response)
        .then(response => {
          this.formExtend.forms = Object.assign({}, response.result)
            if (this.provinceId) {
              this.formExtend.forms.provinceId = this.provinceId
            }else {
              this.formExtend.forms.provinceId = ''
            }
            this.FetchGetArea(this.provinceId, 2, 2)
        this.formExtend.forms.regisArea =  this.formExtend.forms.provinceName+this.formExtend.forms.cityName+this.formExtend.forms.countyName
    })
        .catch(error => {
          console.log(error)
        })  
    },

    // 新增，修改门店数据
    SaveStoreInfo(response) {
      SaveStoreInfo(response)
        .then(response => {
          this.submitCallback(response)
        })
        .catch(error => {
          console.log(error)
        })
    },
    // 新增门店信息完成时的回调函数
    submitCallback(response) {
      let type = response.code === 1 ? 'success' : 'error'
      let message = response.message
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === 'success') {
            this.$router.push({
              path: '/baseStoreList',
              query: { refreshportion: true }
            })
          }
          this.loadingState = false
        }
      })
    },
    // 提交
    handleSubmitForm(e) {
      if (e) {
        this.loadingState = true
        this.SaveStoreInfo(Object.assign({}, this.formExtend.forms))
      }
    },
    // 取消
    handleResetForm() {
      this.$router.push('/baseStoreList')
    },
      // 地图标注回调
      getMapInfo(data) {
          this.formExtend.forms.storePosition = data.location;
          this.formExtend.forms.lon = data.lng;
          this.formExtend.forms.lat = data.lat;
          this.storePosition = data.location;
      },
      cityName(name) {
          this.formExtend.forms.regisArea = name;
          this.city = name;
          this.optionMap.city = name;
      },
  }
}
</script>

<style lang="scss" scoped>
.upload-demo {
  width: 300px;
  margin: 10 150px 10px 200px;
}
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 20px 10px;
}
.content-section {
  overflow: auto;
}
.content-section {
  .form-wrapper {
    padding-top: 20px;
    margin: 0 20px;
    background-color: #fff;

    .group_form {
      width: 50%;
      display: inline-block;
      vertical-align: top;
    .el-form-item {
      width: auto;
    .e6-city {
      width: 178px;
    /deep/ .city-input {
      width: 100% !important;
    }
    }
    &:last-child {
       width: calc(100% - 398px);
       max-width: 300px;
    /deep/.el-form-item__content {
      width: 100%;
    .el-button {
      width: 100%;
    &.show_tips::before {
       content: "在地图上标注";
       color: #898c91;
       position: absolute;
     }
    span {
      display: inline-block;
      width: calc(100% - 20px);
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 5px;
    }
    }
    }
    }
    }
    }
  }
}
/deep/.hide .el-upload--picture-card {
  display: none;
}
/deep/ .e6-from--column-2 {
  .el-input {
    width: 300px;
  }
  .el-textarea__inner {
    width: 500px;
  }
}
</style>
